import React, { useEffect, useState } from 'react';
import { Modal, Button as ButtonAntd, Row, Col, Checkbox, Select } from 'antd';
import { DataIndexTableColumnMenuModalContainer } from '../data-index-table-modal.styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import HelpIcon from '@mui/icons-material/Help';
import { DataAOI } from '../../../../types/interfaces';

interface ChildComponentProps {
    setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    menuModalVisible: boolean;
    onClose: () => void;
    record: DataAOI | null;
    setActiveRecord: React.Dispatch<React.SetStateAction<DataAOI | null>>;
    tableData?: DataAOI[] | [];
}

export const AoisProcessingMenu: React.FC<ChildComponentProps> = ({ setModalVisible, menuModalVisible, onClose, record, setActiveRecord, tableData }) => {
    
    const openLasModal = () => {
        console.log(menuModalVisible)
        setModalVisible(true);
    };

    const handleAoiData = (value: any) => {
        let selectedRecord = tableData?.filter((item) => item.h3_index === value);
        if (selectedRecord && selectedRecord.length > 0) {
            setActiveRecord(selectedRecord[0]);
        } else {
            setActiveRecord(record);
        }
    };


    return (
        <Modal
            title={<span style={{ color: '#fff', fontSize: '20px' }}>Processing Menu</span>}
            centered
            open={menuModalVisible}
            onCancel={onClose}
            footer={null}
            className='process_modal'
        >
            <DataIndexTableColumnMenuModalContainer>
                <div className='processing_data_block'>
                    <label>Choose Aois</label>
                        <Select
                            showSearch
                            placeholder="Select a group"
                            style={{ width: 300 }}
                            optionFilterProp="children"
                            className='aoi_select'
                            onChange={handleAoiData}
                            value={record?.name || ""}
                        >
                            {tableData && tableData.map((option) => (
                                <Select.Option key={option.h3_index} value={option.h3_index}>
                                    {option.name}
                                </Select.Option>
                            ))}
                        </Select>
                </div>
                <div className="inputData_table" style={{ opacity: record === null ? 0.2 : 1 }}>
                    <TableContainer component={Paper} className='process_modal_table'>
                        <Table aria-label="Aois Menu Table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Process</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Help</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <ButtonAntd className="export-dialog-open" disabled={record === null} onClick={openLasModal}>Export To LAS</ButtonAntd>
                                    </TableCell>
                                    <TableCell>Export LAS Data</TableCell>
                                    <TableCell className='help_icon_center'>
                                        <HelpIcon className="help_icon" />
                                    </TableCell>
                                </TableRow>
                                {/* <TableRow>
                                    <TableCell>
                                        <ButtonAntd className="export-dialog-open" disabled={record === null}>Grid to DEM</ButtonAntd>
                                    </TableCell>
                                    <TableCell>Grid to DEM</TableCell>
                                    <TableCell className='help_icon_center'>
                                        <HelpIcon className="help_icon" />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <ButtonAntd className="export-dialog-open" disabled={record === null}>Extract from USGS 1m grid</ButtonAntd>
                                    </TableCell>
                                    <TableCell>Extract from USGS 1m grid</TableCell>
                                    <TableCell className='help_icon_center'>
                                        <HelpIcon className="help_icon" />
                                    </TableCell>
                                </TableRow> */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

            </DataIndexTableColumnMenuModalContainer>
        </Modal>
    )
}